import React from 'react'
import * as THREE from "three"
import { useLoader} from "@react-three/fiber"
import { useCubeTexture } from '@react-three/drei'
import { usePlane } from "@react-three/cannon"
import groundTex from "../../../Assets/Ground/Grey Noise.jpg"
import groundNorm from "../../../Assets/Ground/Grey Noise Normal.jpg"

const Ground = ({size}) => {
    const [ref] = usePlane(() => ({ rotation: [-Math.PI / 2, 0, 0], position : [0,0,0] }))


    const texture = useLoader(THREE.TextureLoader, groundTex)
    const normTex = useLoader(THREE.TextureLoader, groundNorm)

    const envMap = useCubeTexture(['Right.jpg', 'Left.jpg', 'Top.jpg', 'Bottom.jpg', 'Front.jpg', 'Back.jpg'], { path: 'Cube/type1-center/' })

    texture.wrapS = texture.wrapT = THREE.RepeatWrapping
    normTex.wrapS = normTex.wrapT = THREE.RepeatWrapping
    texture.repeat.set(size, 300)
    normTex.repeat.set(size, 300)

    return (
      <mesh 
        ref={ref} 
        receiveShadow
        // onClick = {(e) => clicked(e)}
        >
        <planeGeometry args={[size+50,300]} />
        <meshPhongMaterial
          map={texture}
          color={"#AEAEAE"}
          side = {THREE.DoubleSide}
          normalMap = {normTex}
          envMap={envMap}
          reflectivity={0.34}
        />
      </mesh>
    )
}

export default Ground
